export default __webpack_public_path__ + "static/media/auditorio.a8972544.jpg";